import { render, staticRenderFns } from "./CommentArticle.vue?vue&type=template&id=a752c5ba&scoped=true"
import script from "./CommentArticle.vue?vue&type=script&lang=js"
export * from "./CommentArticle.vue?vue&type=script&lang=js"
import style0 from "./CommentArticle.vue?vue&type=style&index=0&id=a752c5ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a752c5ba",
  null
  
)

export default component.exports